module.exports = __webpack_public_path__ + "img/ic_xls_download@2x.d26f9ab5.png";